export var TextTypeEnum;
(function (TextTypeEnum) {
    TextTypeEnum["BOLD"] = "bold";
    TextTypeEnum["ITALIC"] = "italic";
    TextTypeEnum["UNDERLINE"] = "underline";
    TextTypeEnum["INLINECODE"] = "inlineCode";
})(TextTypeEnum || (TextTypeEnum = {}));
